import React from 'react';
import { useFavourites } from '../../context/FavouritesContext';
import { useNavigate } from 'react-router-dom';
import './FavouritesPage.css';

export default function FavouritesPage() {
  const { favourites, toggleFavourite } = useFavourites();
  const navigate = useNavigate();

  return (
    <div className="fav">
      <div className="fav__inner">

        {/* Header */}
        <div className="fav__header">

          {/* Back button */}
          <button className="fav__back" onClick={() => navigate('/')}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            Back to Home
          </button>

          <p className="fav__eyebrow">Y o u r &nbsp; W i s h l i s t</p>
          <h1 className="fav__title">FAVOURITES</h1>
          <p className="fav__sub">
            {favourites.length === 0
              ? 'Nothing saved yet — start exploring.'
              : `${favourites.length} item${favourites.length !== 1 ? 's' : ''} saved`}
          </p>
        </div>

        {favourites.length === 0 ? (
          <div className="fav__empty">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none"
              stroke="#ddd" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
            </svg>
            <p>Your favourites list is empty</p>
            <button onClick={() => navigate('/products')}>
              Browse Products
            </button>
          </div>
        ) : (
          <div className="fav__grid">
            {favourites.map(fav => (
              <div key={fav.id} className="fav-card">
                {/* Image */}
                <div
                  className="fav-card__img"
                  onClick={() => navigate('/products')}
                >
                  <img src={fav.product_image} alt={fav.product_name} />
                  {/* Remove heart */}
                  <button
                    className="fav-card__remove"
                    onClick={e => {
                      e.stopPropagation();
                      toggleFavourite({ id: fav.product_id });
                    }}
                    aria-label="Remove from favourites"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24"
                      fill="currentColor" stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
                    </svg>
                  </button>
                </div>

                {/* Info */}
                <div className="fav-card__info">
                  <p className="fav-card__brand">{fav.product_brand}</p>
                  <p className="fav-card__name">{fav.product_name}</p>
                  <p className="fav-card__price">R {fav.product_price?.toLocaleString()}</p>
                </div>

                {/* CTA */}
                <button
                  className="fav-card__view"
                  onClick={() => navigate('/products')}
                >
                  View Product
                </button>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}